import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { McIcon } from '@maersk-global/mds-react-wrapper/components-core/mc-icon';

const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

const ConflictsSummaryCard = ({
  title = 'CONFLICTING CHANGES',
  subtitle = 'Upcoming 30 days',
  conflictCount = 0,
  isLoading = false,
  onCardClick,
  isActive = false
}) => {
  const isClickable = typeof onCardClick === 'function' && conflictCount > 0;

  const handleCardActivation = (event) => {
    if (!isClickable) return;
    if (event?.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    if (event?.type === 'keydown') {
      event.preventDefault();
    }
    onCardClick();
  };

  const renderContent = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, textAlign: 'left', fontFamily: maerskFontFamily, flexGrow: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '12px',
            background: '#ede9fe',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <McIcon icon="lightning" size="24" />
        </Box>
        <Box>
          <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, letterSpacing: '0.08em', color: '#4b5563', fontFamily: maerskFontFamily }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontFamily: maerskFontFamily }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Typography sx={{ fontSize: '34px', fontWeight: 600, color: '#111827', lineHeight: 1, fontFamily: maerskFontFamily }}>
        {conflictCount}
      </Typography>
      <Typography sx={{ fontSize: '0.95rem', color: '#4b5563', fontFamily: maerskFontFamily }}>
        Review conflict groups to prevent overlapping deployments.
      </Typography>
    </Box>
  );

  return (
    <Box
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={handleCardActivation}
      onKeyDown={handleCardActivation}
      sx={{
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 2,
        padding: '20px',
        border: isActive ? '2px solid #42b0d5' : '1px solid #9ca3af',
        minHeight: 180,
        fontFamily: maerskFontFamily,
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        opacity: isClickable ? 1 : 0.7,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {isLoading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
          <CircularProgress />
        </Box>
      ) : (
        renderContent()
      )}
    </Box>
  );
};

export default ConflictsSummaryCard;
